import {EventEmitter} from "@angular/core";
import {Filter} from "../ngx-types";
import {NgxFiltersService} from "../ngx-filters.service";

export abstract class NgxFilterBaseComponent {
  abstract filter: Filter;
  abstract label: string;
  abstract value: any;
  abstract valueChange: EventEmitter<any>;
  abstract options: any;
  filterService: NgxFiltersService;
}
